/**
 * @fileoverview ListRenderer component for the Storyteller web application.
 * Renders a list of items with optional icons.
 *
 * @example
 * // Basic usage
 * <ListRenderer items={[{ text: 'Item 1', icon: 'icon-1' }, { text: 'Item 2', icon: 'icon-2' }]} />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { useTranslation } from 'react-i18next'
import { List } from '../../sections/List'

/**
 * @function ListRenderer
 * @description Component for rendering a list of items with optional icons.
 * @param {LabelProps & VanillaRendererProps} props - The props for the ListRenderer component.
 * @returns {JSX.Element} The ListRenderer component.
 */
function ListRenderer(props: LabelProps & VanillaRendererProps) {
    const { t } = useTranslation()
    if (!props.uischema.options) {
        throw Error('ListRenderer: uischema.options is undefined')
    }

    const { items } = props.uischema.options
    const list = items.map(({ text, icon }: Novoic.ListItem) => ({ text: t(text), icon: t(icon) }))

    return <List list={list} />
}

export const ListTester = rankWith(3, uiTypeIs('List'))

export default withVanillaControlProps(withJsonFormsLabelProps(ListRenderer))
